'use client'

import { useEffect, useState } from 'react'

import { Arrow } from '@/components/icons'
import { Button } from '@/ui/button/Button'

const HomeButton = ({
  children,
  className,
  onClick,
  visible = true,
  hasArrowIcon = true,
}: {
  children: React.ReactNode
  className?: string
  onClick?: () => void
  visible?: boolean
  hasArrowIcon?: boolean
}) => {
  const [isHover, setIsHover] = useState(false)
  const [shouldRender, setShouldRender] = useState(visible)
  const [isAnimating, setIsAnimating] = useState(visible)

  useEffect(() => {
    if (visible) {
      setShouldRender(true)
      setTimeout(() => {
        setIsAnimating(true)
      }, 10)
    } else {
      setIsAnimating(false)
      const timer = setTimeout(() => {
        setShouldRender(false)
      }, 300)
      return () => clearTimeout(timer)
    }
  }, [visible])

  if (!shouldRender) return null

  return (
    <Button
      onClick={onClick}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      className={`transition-all duration-300 ease-in-out ${className || ''} ${
        isAnimating ? 'scale-100 opacity-100' : 'scale-95 opacity-0'
      }`}
      style={{
        backgroundColor: isHover ? '#FFFFFF' : '#DA291C',
        color: isHover ? '#DA291C' : '#FFFFFF',
      }}>
      <>
        {children}
        {hasArrowIcon && <Arrow width={16} height={16} color={isHover ? '#DA291C' : 'white'} />}
      </>
    </Button>
  )
}

export { HomeButton }
